import { Objects } from "./objects";

export class JwtPayload {
    static ofToken(token: string): JwtPayload {
        if (token == null || token.trim() === '') {
            return null;
        }

        let parts = token.split('.');
        if (parts.length !== 3) {
            return null;
        }

        try {
            let payloadBase64 = parts[1]
                .replace(/-/g, '+')
                .replace(/_/g, '/');

            let decoded = atob(payloadBase64);
            let json = decodeURIComponent(decoded.split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));

            return Objects.fromPlainUnsafe(JwtPayload, Objects.fromJson(json));
        }
        catch {
            return null;
        }
    }

    exp?: number;
    nbf?: number;
    iat?: number;
    [key: string]: unknown;
    
}